
interface SequencedData {
    sequence: number
}

const MAX_PENDING_DATA = 10
const MAX_DATA_AGE_MS = 500

interface TimestampedData<DataType> {
    added: number
    data: DataType
}

export class SequencedDataReceiver<DataType extends SequencedData> {
    private readonly lastReleasedData: TimestampedData<DataType>[] = []

    private readonly onData: (data: DataType) => void
    private readonly onSequenceError: (lastSequence: number | undefined, now: number, errorReason: string, pendingData: TimestampedData<DataType>[], lastReleasedData: TimestampedData<DataType>[]) => void

    private readonly data: TimestampedData<DataType>[] = []
    private lastSequence?: number | undefined
    private orderBroken = false

    constructor(onData: (data: DataType) => void, onSequenceError: (lastSequence: number | undefined, now: number, errorReason: string, pendingData: TimestampedData<DataType>[], lastReleasedData: TimestampedData<DataType>[]) => void) {
        this.onData = onData
        this.onSequenceError = onSequenceError

        setInterval(() => this.checkDataAge(), MAX_DATA_AGE_MS)
    }

    addData(data: DataType) {
        if(this.orderBroken) return

        this.data.push({
            added: Date.now(),
            data: data,
        })

        if(this.data.length > MAX_PENDING_DATA) {
            this.orderBroken = true
            this.onSequenceError(this.lastSequence, Date.now(), `Too many pending entries: ${this.data.length}`, this.data, this.lastReleasedData)
            return
        }

        if(this.lastSequence == undefined) {
            this.lastSequence = data.sequence - 1
        }

        while(this.releaseNextData()) {
            //
        }
    }

    private releaseNextData(): boolean {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextDataIndex = this.data.findIndex((data) => data.data.sequence == this.lastSequence! + 1)
        if(nextDataIndex < 0) return false

        const nextData = this.data[nextDataIndex].data

        this.lastSequence = nextData.sequence
        this.onData(nextData)

        if(this.lastReleasedData.push(this.data[nextDataIndex]) > 5) {
            this.lastReleasedData.shift()
        }

        this.data.splice(nextDataIndex, 1)

        return this.data.length > 0
    }

    reset() {
        this.lastSequence = undefined
        this.orderBroken = false
        this.data.length = 0
        this.lastReleasedData.length = 0
    }

    private checkDataAge() {
        if(this.orderBroken) return

        for(const data of this.data) {
            if(Date.now() - data.added < MAX_DATA_AGE_MS) continue

            this.orderBroken = true
            this.onSequenceError(this.lastSequence, Date.now(), `Missing entry did not arrive in ${MAX_DATA_AGE_MS}ms`, this.data, this.lastReleasedData)
            return
        }
    }
}
